import {useEffect, useState} from 'react';

import {useStores} from '../../../../stores/use-stores';

// Just trying to refactor things out of those platform-dependent
// CardTokeniserTill.tsx files looking to one day unify them as
// we have done with others.

// Load the public integration key from MFL
const useTillServiceIntegrationKeyEffect = (isVisible: boolean) => {
  const {paymentStore} = useStores();
  const [integrationKey, setIntegrationKey] = useState<string | null>(null);

  useEffect(() => {
    async function getToken() {
      if (isVisible && paymentStore.tillPaymentService) {
        const data = await paymentStore.getTokenizationDataForTillService();
        setIntegrationKey(data.fields?.public_integration_key);
      }
    }
    getToken();
  }, [isVisible, paymentStore, paymentStore.tillPaymentService]);

  return {integrationKey, setIntegrationKey};
};

export default useTillServiceIntegrationKeyEffect;
